import { secondsToTimeStr } from "@common/utils/datetime";

export let browserFocused = true;
export function setBrowserFocused(focused: boolean) {
  browserFocused = focused;
}

export function sendNotification(
  title: string,
  body: string,
  icon: "break" | "tick" | "sun"
) {
  // notify using notifications
  if (Notification.permission === "granted") {
    if (!browserFocused) {
      new Notification(title, {
        body,
        icon: `/${icon}.svg`,
      });
    }
  } else {
    Notification.requestPermission();
  }
}

export function sendTodoTimerDoneNoti(
  todoValue: string,
  mode: "auto" | "manual",
  breakDuration?: number,
  nextTodoValue?: string
) {
  const title = `DONE: ${todoValue}`;
  const breakDurStr = breakDuration ? secondsToTimeStr(breakDuration) : "";
  let body = "";

  switch (mode) {
    case "manual":
      body = "Timer Completed";
      sendNotification(title, body, "tick");
      break;

    case "auto":
      const hasNextTodo = nextTodoValue !== undefined;
      const hasNextBreak = hasNextTodo && breakDuration !== 0;
      if (hasNextBreak) {
        body = `START: Break for ${breakDurStr}`;
        sendNotification(title, body, "break");
      } else if (hasNextTodo) {
        // no break, straight to next todo
        body = `START: ${nextTodoValue}`;
        sendNotification(title, body, "sun");
      } else {
        body = "No more timed tasks";
        sendNotification(title, body, "tick");
      }
      break;
    default:
      break;
  }
}

export function sendBreakOverNoti(nextTodoValue?: string) {
  if (!nextTodoValue) {
    sendNotification(`DONE: Break's Over!`, "No more timed tasks", "tick");
  }

  sendNotification(`DONE: Break's Over!`, `NEXT: ${nextTodoValue}`, "sun");
}

export function sendInProgressBreakOverNoti(todoValue?: string) {
  if (!todoValue) {
    sendNotification(`DONE: Break's Over!`, "Choose next task", "tick");
  }

  sendNotification(`DONE: Break's Over!`, `CONTINUE: ${todoValue}`, "sun");
}
